import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-headerpicture',
  templateUrl: './headerpicture.component.html',
  styleUrls: ['./headerpicture.component.css'],
})
export class HeaderpictureComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
